import { formatLongDate } from "@/lib/formatDate";
import { useFeatureFlag } from "@/store/featureFlagStore";
import { useItemHistoryActor } from "./useItemHistoryActor";
import { useItemLastCostChange } from "./useItemLastCostChange";

/**
 * "Last updated by … on …" under the unit cost, from the item's saved change
 * log. Renders nothing with the item-history flag off or when no saved write
 * changed the cost.
 * @param itemId - The item whose unit cost this describes
 */
export const ItemCostLastUpdated = ({ itemId }: { itemId: string }) => {
  const isItemHistoryEnabled = useFeatureFlag("item-history");
  const event = useItemLastCostChange(itemId);
  const resolveActor = useItemHistoryActor();
  if (!isItemHistoryEnabled || !event) {
    return null;
  }
  const actor = resolveActor(event);
  const by = actor.behalf
    ? `${actor.name} on behalf of ${actor.behalf.name}`
    : actor.name;
  return (
    <p className="col-span-full text-xs text-muted-foreground">
      Last updated by {by} on {formatLongDate(event.createdAt)}
    </p>
  );
};
